import React, { useEffect, useState } from "react";

const DropdownSection = ({ defaultOpen, children, label, onClick}) => {
  const [open, setOpen] = useState(defaultOpen || false)

  const onHeaderClick = (e) => {
    setOpen(!open)
    if(onClick) {
      onClick(e, !open)
    }
  }
  return (
    <div 
      className={`catalog-items-form-dropdown-section ${open ? "open" : "closed"}`}
    >
      <div className="catalog-items-form-dropdown-section-header" onClick={(e) => onHeaderClick(e)}>
        <img src="/images/icons/ChevronRight.svg" className="catalog-items-form-dropdown-section-header-chevron"/>
        {label}
      </div>
      <div className="catalog-items-form-dropdown-section-content">
        {children}
      </div>
    </div>
  )

  
}

export default DropdownSection